import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import createDebounce from 'redux-debounced';
import { composeWithDevTools } from 'redux-devtools-extension';
import reducer from './reducers';

const store = createStore(reducer, composeWithDevTools(applyMiddleware(createDebounce(), thunk)));

export default store;



// WEBPACK FOOTER //
// ./src/redux/store.js